/* ============================================================================
   AEYLA LISTICLE (7-REASON)  ·  window.__aeylaListicle7 namespace
   ----------------------------------------------------------------------------
   Testimonials carousel uses native scroll-snap + JS for dots/buttons/autoplay.
   Sticky bar uses rAF-throttled scroll handler.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__aeylaListicle7) return;
  window.__aeylaListicle7 = { initialized: false };

  var SCOPE = '.shopify-section.section-aeyla-listicle-7';
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }

  function initTestimonials(section) {
    var car = section.querySelector('[data-testimonials]');
    if (!car) return;
    var viewport = car.querySelector('[data-testimonials-viewport]');
    var track = car.querySelector('[data-testimonials-track]');
    var dotsWrap = car.querySelector('[data-testimonials-dots]');
    if (!viewport || !track) return;
    var slides = $$('[data-testimonials-slide]', track);
    if (slides.length === 0) return;

    var idx = 0;
    var total = slides.length;
    var autoplay = car.getAttribute('data-autoplay') === 'true';
    var autoplayMs = parseInt(car.getAttribute('data-autoplay-ms') || '6500', 10);
    var timer = null;
    var scrollDebounce = null;

    function scrollToIdx(i, behavior) {
      var slide = slides[i];
      if (!slide) return;
      var slideRect = slide.getBoundingClientRect();
      var viewportRect = viewport.getBoundingClientRect();
      var target = viewport.scrollLeft + slideRect.left - viewportRect.left - (viewportRect.width - slideRect.width) / 2;
      viewport.scrollTo({ left: target, behavior: behavior || 'smooth' });
    }

    function syncDotsTo(i) {
      if (!dotsWrap) return;
      $$('.ay7__testimonials-dot', dotsWrap).forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
      });
    }

    function go(d) {
      idx = (idx + d + total) % total;
      scrollToIdx(idx);
      syncDotsTo(idx);
      restartAutoplay();
    }

    function startAutoplay() {
      if (!autoplay || total <= 1) return;
      timer = setInterval(function () {
        idx = (idx + 1) % total;
        scrollToIdx(idx);
        syncDotsTo(idx);
      }, autoplayMs);
    }
    function stopAutoplay() { if (timer) { clearInterval(timer); timer = null; } }
    function restartAutoplay() { stopAutoplay(); startAutoplay(); }

    function onScroll() {
      if (scrollDebounce) cancelAnimationFrame(scrollDebounce);
      scrollDebounce = requestAnimationFrame(function () {
        var viewportRect = viewport.getBoundingClientRect();
        var center = viewportRect.left + viewportRect.width / 2;
        var closest = 0;
        var minDist = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var r = slides[i].getBoundingClientRect();
          var slideCenter = r.left + r.width / 2;
          var d = Math.abs(slideCenter - center);
          if (d < minDist) { minDist = d; closest = i; }
        }
        if (closest !== idx) {
          idx = closest;
          syncDotsTo(idx);
        }
      });
    }

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'ay7__testimonials-dot' + (i === idx ? ' is-active' : '');
        d.setAttribute('aria-label', 'Go to testimonial ' + (i + 1));
        (function (k) {
          on(d, 'click', function () { idx = k; scrollToIdx(idx); syncDotsTo(idx); restartAutoplay(); });
        })(i);
        dotsWrap.appendChild(d);
      }
    }

    on(car.querySelector('[data-testimonials-dir="prev"]'), 'click', function () { go(-1); });
    on(car.querySelector('[data-testimonials-dir="next"]'), 'click', function () { go(1); });
    on(viewport, 'scroll', onScroll, { passive: true });

    on(car, 'mouseenter', stopAutoplay);
    on(car, 'mouseleave', startAutoplay);
    on(viewport, 'touchstart', stopAutoplay, { passive: true });

    requestAnimationFrame(function () {
      scrollToIdx(idx, 'auto');
      syncDotsTo(idx);
      startAutoplay();
    });
  }

  function initStickyBar(section) {
    var bar = section.querySelector('[data-sticky]');
    if (!bar) return;
    var showAfter = parseInt(bar.getAttribute('data-show-after') || '700', 10);
    var hideNearEnd = parseInt(bar.getAttribute('data-hide-near-end') || '92', 10);
    var ticking = false;
    function update() {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var y = h.scrollTop || window.pageYOffset;
      var pct = max > 0 ? (y / max * 100) : 0;
      var shouldShow = y > showAfter && pct < hideNearEnd;
      bar.classList.toggle('is-visible', shouldShow);
      ticking = false;
    }
    on(window, 'scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    on(window, 'resize', update);
    update();
  }

  function init() {
    if (window.__aeylaListicle7.initialized) return;
    window.__aeylaListicle7.initialized = true;
    $$(SCOPE).forEach(function (section) {
      initTestimonials(section);
      initStickyBar(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('section-aeyla-listicle-7')) {
      window.__aeylaListicle7.initialized = false;
      init();
    }
  });
})();